var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pauseButtonTippy",
    role: "img",
    "aria-labelledby": titleId,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 47",
    width: 15,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pauseButton"
  }, "pause promo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pauseButton"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 47,
    rx: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 17,
    height: 47,
    rx: 2.2
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseIcon);
export default ForwardRef;